import { useTranslation } from 'react-i18next';
import Card from './Card';

export const ResultsCountdown = ({ countdown }) => {
	const { t } = useTranslation();
	return (
		<div className='container-game flex flex-col items-center justify-center min-h-screen'>
			<Card className='text-center py-12 px-8 bg-gradient-to-r from-purple-500 to-blue-500 shadow-xl'>
				<div className='relative overflow-hidden'>
					<div className='absolute -top-10 -left-10 w-20 h-20 bg-blue-400 rounded-full animate-ping opacity-75'></div>
					<div className='absolute -top-10 -right-10 w-20 h-20 bg-purple-400 rounded-full animate-ping opacity-75 delay-300'></div>
					<div className='absolute -bottom-10 -left-10 w-20 h-20 bg-indigo-400 rounded-full animate-ping opacity-75 delay-150'></div>
					<div className='absolute -bottom-10 -right-10 w-20 h-20 bg-blue-400 rounded-full animate-ping opacity-75 delay-500'></div>

					<h2 className='text-4xl font-extrabold mb-6 text-white animate-pulse drop-shadow-lg transform scale-110'>
						{t('resultsCountdownView.title')}
					</h2>
					<div className='text-9xl font-bold text-white animate-bounce drop-shadow-lg'>{countdown}</div>
					<p className='mt-6 text-2xl text-white font-semibold animate-pulse'>
						{t('resultsCountdownView.findOutWhoWonMessage')}
					</p>
				</div>
			</Card>
		</div>
	);
};
